const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 21.313 18.516"
      className="fill-current"
    >
      <path
        id="Path_12218"
        data-name="Path 12218"
        d="M.042,0,0,2.479l8.662,7.932v8.1l3.989-1.787V10.383l8.662-8.221V0Z"
        transform="translate(0 0)"
      />
    </svg>
  )
}

export default FilterIcon
